import "bootstrap";
import 'bootstrap/dist/css/bootstrap.css' // Import precompiled Bootstrap css
import '@fortawesome/fontawesome-free/css/all.css'
import 'ol/ol.css';
import './css/site.css';

import Router from 'vue-router'
import Vue from 'vue';
import Login from './components/Login';
import Settings from './components/settings/Settings';
import BasicVisualizationList from './components/visualizations/VisualizationList';
import VisualizationView from './components/visualizations/VisualizationView';

import GroupAdd from './components/settings/groups/GroupAdd';
import GroupDetail from './components/settings/groups/GroupDetail';
import GroupList from './components/settings/groups/GroupList'; 

import UserAdd from './components/settings/users/UserAdd';
import UserDetail from './components/settings/users/UserDetail';
import UserList from './components/settings/users/UserList';

import VisualizationList from './components/settings/visualizations/VisualizationList';
import VisualizationDetail from './components/settings/visualizations/VisualizationDetail';
import VisualizationAdd from './components/settings/visualizations/VisualizationAdd';

import DataTableDetail from './components/settings/datatables/DataTableDetail';
import DataTableList from './components/settings/datatables/DataTableList';

import ImageTableDetail from './components/settings/images/ImageTableDetail';
import ImageTableList from './components/settings/images/ImageTableList.vue';

import LayerList from './components/settings/layers/LayerList';
import LayerDetail from './components/settings/layers/LayerDetail';
import LayerAdd from './components/settings/layers/LayerAdd';

import AuthorizationApi from "./api/server/authorization";

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/visualizations',
            name: 'visualizations',
            component: BasicVisualizationList
        },
        {
            path: '/settings',
            name: "settings",
            component: Settings,
            props: true,
            children: [
                {
                    path: 'users',
                    name: "users",
                    component: UserList
                },
                {
                    path: 'groups',
                    name: "groups",
                    component: GroupList
                },
                {
                    path: 'visualizations',
                    name: "visualizations",
                    component: VisualizationList
                },
                {
                    path: 'datatables',
                    name: "datatables",
                    component: DataTableList
                },
                {
                    path: 'imagetables',
                    name: "imagetables",
                    component: ImageTableList
                },
                {
                    path: 'layers',
                    name: "layers",
                    component: LayerList
                }
            ]
        },
        // USERS 
        {
            path: '/useradd',
            name: 'useradd',
            component: UserAdd
        },
        {
            path: '/userdetail/:id',
            name: 'userdetail',
            component: UserDetail,
            props: true
        },
        //GROUPS - SETTINGS
        {
            path: '/groupadd',
            name: 'groupadd',
            component: GroupAdd
        },
        {
            path: '/groupdetail/:id',
            name: 'groupdetail',
            component: GroupDetail,
            props: true
        },
        //ADMIN - DATA TABLES
        {
            path: '/visualizationdetail/:id',
            name: 'visualizationdetail',
            component: VisualizationDetail,
            props: true
        },
        {
            path: '/visualizationview/:id',
            name: 'visualizationview',
            component: VisualizationView,
            props: true
        },
        {
            path: '/visualizationadd',
            name: 'visualizationadd',
            component: VisualizationAdd,
            props: true
        },
        {
            path: '/datatabledetail/:id',
            name: 'datatabledetail',
            component: DataTableDetail,
            props: true
        },
        {
            path: '/imagetabledetail/:id',
            name: 'imagetabledetail',
            component: ImageTableDetail,
            props: true
        },
        {
            path: '/layerdetail/:id',
            name: 'layerdetail',
            component: LayerDetail,
            props: true
        },
        {
            path: '/layeradd',
            name: 'layeradd',
            component: LayerAdd,
            props: true
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    var auth = await AuthorizationApi.auth();
    if (to.name !== 'login' && !auth.isAuthenticated) {
        next({
            name: 'login',
            query: { returnUrl: to.fullPath }
        });
    } else {
        next();
    }
});

if (!window.indexedDB) {
    console.log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
}

export default router;